<template>
  <div class="cat-score-column-wrapper">
    <div class="cat-score-title">{{categoryName}} <tool-tip :index="catIndex"></tool-tip></div>
    <div class="cat-scores-wrapper">
      <div class="score-block">
        <color-block
        :score="columnAScore"
        :ishovered="false"
        :name="categoryName">
        </color-block>
      </div>
      <div class="score-block">
        <color-block
        :score="columnBScore"
        :ishovered="false"
        :name="categoryName">
        </color-block>
      </div>
    </div>
  </div>
</template>

<script>
import MapColorBlock from '../MapColorBlock';
import ToolTip from '../ToolTip';

export default {
  name: 'category-scores',
  props: ['categoryName', 'columnAScore', 'columnBScore', 'catIndex'],
  components: {
    'color-block': MapColorBlock,
    'tool-tip': ToolTip,
  },
};
</script>

<style lang="less">
  .cat-score-column-wrapper {
    margin-right: 10px;
    flex: 0 1 27%;
    @media (max-width: 800px) {
     flex: 0 1 44%; 
    }
  }
  .cat-scores-wrapper {
    display: flex;
    width: 100%;
  }
  .cat-score-title {
    flex: 1 0;
    font-size: 18px;
    font-weight: bold;
    //text-transform: uppercase;
  }
  .score-block {
    height: 60px;
    flex: 0 1 50%;
    padding: 10px 10px 10px 0;
  }
  .cat-tooltip-wrapper {
    color: #d4d2d2;
  }
</style>



// WEBPACK FOOTER //
// CategoryScoreColumn.vue?600e2f51